import { QueryClient } from '@tanstack/react-query'
import { isApiError } from '@/lib/api/errors'

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        // Never retry auth or permission errors; retry others once.
        retry: (count, error) =>
          !(error instanceof DOMException && error.name === 'AbortError') &&
          !(isApiError(error) && error.status >= 400 && error.status < 500) &&
          count < 1,
      },
    },
  })
}
